// based on rc-checkbox 2.1.6
export { default } from './src/';